"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusRing = void 0;
const styled_components_1 = require("styled-components");
const FocusRing_1 = require("../tokens/global/FocusRing");
exports.focusRing = (0, styled_components_1.css) `
    &:focus {
        outline: none;
        box-shadow: 0 0 0 ${FocusRing_1.focusRingTokens.focusRingSeparatorWidth.getVar()}
                ${FocusRing_1.focusRingTokens.focusRingSeparatorColor.getVar()},
            0 0 0 ${FocusRing_1.focusRingTokens.focusRingMainWidth.getVar()}
                ${FocusRing_1.focusRingTokens.focusRingMainColor.getVar()};
    }
`;
//# sourceMappingURL=focusRing.styles.js.map